
export function CTASection() {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 relative overflow-hidden">
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-white mb-4 sm:mb-6">
          ¿Listo para transformar tu vida?
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-6 sm:mb-8 leading-relaxed">
          Únete hoy y comienza a generar ingresos con productos digitales
        </p>
        <a
          href="https://pay.hotmart.com/I103812749W?off=gkmu5rxa&checkoutMode=10"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block w-full sm:w-auto px-6 sm:px-8 lg:px-10 py-4 sm:py-5 rounded-xl sm:rounded-2xl font-bold text-sm sm:text-base lg:text-xl bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500 text-white hover:shadow-2xl hover:shadow-emerald-500/50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer animate-pulse border-2 sm:border-4 border-white/50"
        >
          🚀 COMENZAR AHORA POR $20 🚀
        </a>
      </div>
    </section>
  );
}
